import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { toggle } from 'libs/util/boolean';
import { Button } from 'components/Button';
import { Closeable } from 'components/util/Closeable';
import { React } from 'libs/react';
import { FileButton } from 'components/FileButton';
import { GenerateDealMutation } from 'graphql/Deal/mutations/GenerateDealMutation';
import { ButtonGroup } from 'components/ButtonGroup';
import { useDomain } from 'components/domain/DomainProvider';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import './QuoteHeaderMenu.scss';
/**
 * @component QuoteHeaderMenu
 * @since 1.0.0
 */
export function QuoteHeaderMenu(props) {
    var _a;
    const { data, hasApproval, onDiscuss } = props;
    if (data == null) {
        return null;
    }
    const { configurationFields } = useDomain();
    let hasChat = configurationFields
        ? getConfigurationFieldValue(configurationFields, 'CHAT_ENABLED')
        : null;
    if (data.user &&
        [
            'ce6fb37bb3f9472d840b4a828cc7468d',
            '2050849d1fda4daa88d234718356769d',
            'a5cb986c7fbc47c2b75ccd302dc82fe0',
            'aab79aee46b9493884ef73687a1fcd88',
            '3b1931fa2b8543fb85d31f02c8e1ecce'
        ].includes((_a = data.user) === null || _a === void 0 ? void 0 : _a.id)) {
        hasChat = 'TRUE';
    }
    else {
        hasChat = 'FALSE';
    }
    const [opened, setOpened] = useState(false);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        setOpened(toggle);
    }
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        setOpened(false);
    }
    /**
     * @function gotoSection
     * @since 1.0.0
     * @hidden
     */
    function gotoSection(id) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setOpened(false);
    }
    /**
     * @function onPressActivity
     * @since 1.0.0
     * @hidden
     */
    const onPressActivity = () => {
        onDiscuss && onDiscuss();
    };
    const className = classNames('quote-header-menu', { 'quote-header-menu--is-opened': opened }, props.className);
    return (React.createElement(Closeable, { onClose: onClose },
        React.createElement("div", { className: className },
            React.createElement(Button, { className: "quote-header-menu-toggler", style: "picto", picto: opened ? 'times' : 'bars', onPress: onClick }),
            React.createElement("div", { className: "quote-header-menu-pane" },
                React.createElement("div", { className: "quote-header-menu-pane-head" },
                    React.createElement(Button, { className: "quote-header-menu-item", style: "plain", label: t('Introduction'), onPress: () => gotoSection('introduction') }), data === null || data === void 0 ? void 0 :
                    data.items.map((item) => (React.createElement(Button, { key: item.id, className: "quote-header-menu-item", style: "plain", label: item.item.title, onPress: () => gotoSection(item.id) }))),
                    data.type !== 'AGREEMENT' &&
                        (data.priceDisplay === 'ALL' ||
                            data.priceDisplay === 'BUNDLED' ||
                            data.priceDisplay === 'TOTAL') && (React.createElement(Button, { className: "quote-header-menu-item", style: "plain", label: t('Budget'), onPress: () => gotoSection('budget') })),
                    (data.contact || data.client) && (React.createElement(Button, { className: "quote-header-menu-item", style: "plain", label: t('Contact'), onPress: () => gotoSection('contact') })),
                    hasApproval == 'TRUE' &&
                        (data.type === 'AGREEMENT' || data.priceDisplay !== 'NONE') &&
                        (data.canBeSigned ||
                            data.directSale ||
                            data.type === 'AGREEMENT') && (React.createElement(Button, { className: "quote-header-menu-item", style: "plain", label: t('Approval'), onPress: () => gotoSection('approval') }))),
                data.canGeneratePDF && (React.createElement("div", { className: "quote-header-menu-pane-foot" },
                    React.createElement(ButtonGroup, { className: "quote-header-menu-actions" },
                        hasChat === 'TRUE' && (React.createElement(Button, { className: "quote-header-menu-action", style: "picto", picto: "comments", onPress: onPressActivity })),
                        data.canGeneratePDF && (React.createElement(FileButton, { picto: "file-pdf", exportMutation: GenerateDealMutation, input: { id: data.id }, className: "quote-header-menu-action", isBinary: false })))))))));
}
